export default "__VITE_ASSET__CChxzp4Y__"